<span>
  @if (onClickFunction) {
      <a (click)="triggerOnClick($event)" href="">
        <mat-icon> {{icon()}} </mat-icon>
      </a>
  } @else {
    @if (showDownload) {
      <a href="{{link()}}" download>
        <mat-icon> {{icon()}} </mat-icon>
      </a>
    } @else {
      <a href="{{link()}}" download>
        <mat-icon> {{icon()}} </mat-icon>
      </a>
    }
  }
</span>
